import React from 'react';
import { Toast, ToastProps } from '@im/ui-lib/zenith/Toast';

type Props = {
  alert: boolean;
  setAlert: (enable: boolean) => void;
  severity: ToastProps['intent'];
  text: string;
};

export function AlertPopup(props: Props) {
  const { alert, setAlert, severity, text } = props;

  const handleClose = () => {
    setAlert(false);
  };

  return (
    <Toast
      autoHideDuration={5000}
      header={undefined}
      icon={severity === 'success' ? 'AlertCircle' : 'CheckCircle'}
      intent={severity}
      onCloseButtonClick={handleClose}
      open={alert}
      position="top-center"
      supportingText={text}
      sx={{ top: '72px!important', width: 'unset' }}
    />
  );
}
